import { useEffect, useState } from 'react';
import { getTenantDomain } from '../clients/TenantProvider';
import { getSearchPath } from '../clients/UrlService';

const FALLBACK_BASE_URL = 'https://www.vistaprint.com/search';

export default function useSearchDomain(
  tenant: string | null,
  locale: string
): { searchBaseUrl: string; isLoading: boolean } {
  const [searchBaseUrl, setSearchBaseUrl] = useState<string>(FALLBACK_BASE_URL);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!tenant) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const loadBaseUrl = async () => {
      setIsLoading(true);
      const [domain, path] = await Promise.all([getTenantDomain(tenant, locale), getSearchPath(tenant, locale)]);
      if (!cancelled) {
        setSearchBaseUrl(`https://${domain}${path}`);
        setIsLoading(false);
      }
    };

    loadBaseUrl();

    return () => {
      cancelled = true;
    };
  }, [tenant, locale]);

  return { searchBaseUrl, isLoading };
}
